import { Phone, Clock, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import probrokerLogo from "../assets/probroker-logo.png";

const usefulLinks = [
  { name: "About Us", path: "/about-us" },
  { name: "Disclaimer", path: "/disclaimer" },
  { name: "Privacy Policy", path: "/privacy-policy" },
  { name: "Terms and Condition", path: "/terms-of-service" },
  { name: "Refund Policy", path: "/refund-policy" },
  { name: "Content Takedown Policy", path: "/content-takedown-policy" },
  { name: "Broker Code of Conduct", path: "/broker-code-of-conduct" },
  { name: "Contact Us", path: "/contact-us" },
];

const socialLinks = [
  { href: "#", icon: Facebook, label: "Facebook" }, 
  { href: "https://www.instagram.com/probroker.in/", icon: Instagram, label: "Instagram" },
  { href: "", icon: Twitter, label: "Twitter" },
  { href: "https://www.youtube.com/@probroker.in_official", icon: Youtube, label: "YouTube" },
];

const ProBrokerFooter = () => (
  <footer className="relative pt-16 sm:pt-20 pb-8 overflow-hidden bg-gradient-to-b from-[hsl(263,45%,18%)] to-[hsl(263,40%,12%)]">
    {/* Watermark - large center yellow */}
    <div 
      className="absolute ml-[490px] top-[380px] -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-[0.13] pointer-events-none select-none"
      style={{ 
        filter: "invert(91%) sepia(86%) saturate(1487%) hue-rotate(352deg) brightness(101%) contrast(105%)" 
      }}
    >
      <img
        src={probrokerLogo}
        alt=""
        className="w-full h-full object-contain"
      />
    </div>

    {/* Watermark - small top left glow */}
    <div className="absolute top-0 left-0 w-64 h-64 bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

    <div className="container mx-auto px-4 sm:px-6 relative z-10">
      {/* 3-column grid */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16 mb-14">

        {/* Column 1 - Brand */}
        <div>
          <img
            src={probrokerLogo}
            alt="PRObroker"
            className="h-8 sm:h-9 brightness-0 invert mb-3"
          />
          <p className="text-white/60 text-sm leading-relaxed mb-6">
            #1 B2B platform for brokers in Ahmedabad
          </p>
          {/* Social Icons */}
          <div className="flex items-center gap-3">
            {socialLinks.map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                className="w-8 h-8 rounded-full border border-white/20 flex items-center justify-center text-white/50 hover:text-white hover:border-white/50 transition-all"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        {/* Column 2 - Contact */}
        <div>
          <h4 className="text-sm font-bold text-white mb-1 pb-2 border-b border-white/30 w-fit pr-8">
            Contact
          </h4>
          <div className="mt-4 space-y-4 text-sm text-white/50">
            <div className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-white/40 mt-0.5 shrink-0" />
              <span>GF-001, Mauryansh Elanza, Shyamal Cross Rd, nr. PAREKH HOSPITAL, SATELITE, Shyamal, Ahmedabad, Gujarat 380015</span>
            </div>
            <a
              href="tel:+918141817353"
              className="flex items-center gap-3 hover:text-white transition-colors"
            >
              <Phone className="w-4 h-4 text-white/40 shrink-0" />
              +91-8141817353
            </a>
            <div className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-white/40 shrink-0" />
              Working Hours: 10AM To 7PM
            </div>
          </div>
        </div>

        {/* Column 3 - Useful Links */}
        <div>
          <h4 className="text-sm font-bold text-white mb-1 pb-2 border-b border-white/30 w-fit pr-8">
            Useful Links
          </h4>
          <ul className="mt-4 space-y-2.5">
            {usefulLinks.map((link) => (
              <li key={link.name}>
                <Link
                  to={link.path}
                  className="text-sm text-white/50 hover:text-white hover:translate-x-0.5 transition-all duration-200 inline-block"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-3">
        <p className="text-xs text-white/30 w-full text-center">
          © 2026 All rights reserved - BROX Venture PVT LTD.
        </p>
        {/* <div className="flex gap-6 text-xs text-white/30">
          <Link to="/privacy-policy" className="hover:text-white transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-of-service" className="hover:text-white transition-colors">
            Terms of Service
          </Link>
        </div> */}
      </div>
    </div>
  </footer>
);

export default ProBrokerFooter;